import React from 'react';
import cn from 'classnames';
import { TitleDesktop } from '../../../../typography/esm';

var styles = {"header":"confirmation__header_g92sq","typography":"confirmation__typography_g92sq","typographyMobile":"confirmation__typographyMobile_g92sq"};
require('./index.css');

var Header = function (_a) {
    var _b;
    var mobile = _a.mobile, children = _a.children;
    return (React.createElement(TitleDesktop, { className: cn(styles.header, styles.typography, (_b = {}, _b[styles.typographyMobile] = mobile, _b)), tag: 'h3', color: 'primary' }, children));
};

export { Header };
